<template><div><h1 id="hauptartikel" tabindex="-1"><a class="header-anchor" href="#hauptartikel"><span>Hauptartikel</span></a></h1>
<p>Hauptartikel — Stammtabelle Hauptartikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Hauptartikeldaten gepflegt. Ein Hauptartikel fasst mehrere gleichartige <RouteLink to="/referenz/refs/ft.refdata.artikel.html" title="Artikel">Artikel</RouteLink> mit unterschiedlichen Merkmalen zusammen (z.B. Pullover in verschiedenen Farben und Grössen).</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Hauptartikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nummer</dt>
<dd>Identifikator des Hauptartikels (alphanumerisch)</dd>
<dt>Bezeichnung d, f, i, e</dt>
<dd>Artikelbezeichnung in 4 Sprachen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.artikel.html" title="Artikel">Artikel</RouteLink></p>
</div></template>


